// Shared application constants

// Total milliseconds the loading spinner stays mounted after data is ready, before it's
// removed: a brief hold at full opacity (SPINNER_FADE_HOLD_DURATION) so the fade doesn't
// start the instant data arrives, then the opacity transition itself. Must match the
// `transition-delay` + `transition` duration on `.is-leaving` (and loading-spinner's
// `:host.is-leaving`) in the corresponding *.scss files.
export const SPINNER_FADE_HOLD_DURATION = 150;
export const SPINNER_FADEOUT_DURATION = SPINNER_FADE_HOLD_DURATION + 300;
